const React = require('react');
const {
  createTheme,
} = require('@material-ui/core/styles');
const {
  ThemeProvider,
} = require('@material-ui/styles');
require('date-fns');
const {
  MuiPickersUtilsProvider,
  DatePicker,
} = require('@material-ui/pickers');
const DateFnsUtils = require('@date-io/date-fns').default;


/* eslint-disable quote-props */
const defaultTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#5B47FF',
      },
    },
    MuiPickersCalendarHeader: {
      iconButton: {
        color: '#444',
        '&:hover': {
          color: '#000',
          backgroundColor: '#EEE',
        },
      },
    },
    MuiPickersYear: {
      root: {
        color: '#BBB',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
      },
      yearSelected: {
        color: '#000',
      },
    },
    MuiPickersDay: {
      day: {
        color: '#444',
      },
      daySelected: {
        backgroundColor: '#5B47FF',
        color: '#FFF',
        '&:hover': {
          backgroundColor: '#4B37EF',
        },
      },
      dayDisabled: {
        color: 'rgba(0, 0, 0, 0.38)',
      },
    },
  },
});


module.exports = ({
  className,
  helperText,
  picker,
  after,
  views,
  ...props
}) => {
  return (
    <div className={className || ''}>
      <div className="rlv">
        <ThemeProvider theme={defaultTheme}>
          <MuiPickersUtilsProvider
            views={views}
            utils={DateFnsUtils}
          >
            <DatePicker
              margin="none"
              variant="dialog"
              inputVariant="outlined"
              format="dd.MM.yyyy"
              {...props}
              views={views}
              InputLabelProps={{
                shrink: true,
              }}
              className={`
w
o50>.MuiInputBase-input.Mui-disabled
(crDefault|bgTransparent)>.MuiInputBase-input.Mui-disabled:h 
(pv19|pt17|hmin56|bxzBB|cF|fw4|ff$2|cr@mouse|crT:f!)>.MuiOutlinedInput-input
ph20>input
(fw4|dn)>(input|textarea):i
o0>.Mui-focused>(input|textarea):i
o100:h>:not[.Mui-focused]>.MuiOutlinedInput-input:i
pv0>textarea.MuiOutlinedInput-input
st-4.5>fieldset
(dn|f15|ov|r8|bgF2:h)>.MuiOutlinedInput-root*2
(bgF2)>.MuiOutlinedInput-root.Mui-disabled*2
(bg04.*-focused!)>.*OutlinedInput-root*3
(b2|bcF.15(>*|:h>*|>.*-focused):not[.*-error])>.*-notchedOutline*2
(f16|ff$2|fw5|x20y19s90|cA3A7AC:not[.*-error]!)>.*InputLabel
cF>[data-shrink=true].*InputLabel:not[.*-error]
cA3A7AC>.MuiIconButton-label
pr8>.*-adornedEnd
cF44336>.MuiFormHelperText-filled
(bgFF7070.05|bcEC4C4C)>.*-error>.*-notchedOutline*2
dN>.MuiFormHelperText-root
f13>.*legendLabelled>span              
              `}
            />
          </MuiPickersUtilsProvider>
          <div className="w24 abs st50% sr20 xY-50%">
            <svg className="dB" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" fill="#A3A7AC" />
              <path fill="none" d="M0 0h24v24H0z" />
            </svg>
          </div>
        </ThemeProvider>
        {props.error ? (<div className="rlv">
          <div
            className="abs sh20 st1 f12 cEC4C4C fw4 ws"
          >{helperText || 'Date is invalid'}</div>
        </div>) : null}
      </div>
    </div>
  );
};
